module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_2250_Inactive@1x-96194c98a245e60ef98e94807688433b.png";